import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');
moment.suppressDeprecationWarnings = true;

export default function time(value = '', options = {}) {
  let result;

  try {
    result = moment(value, options.format);
  } catch (err) { /* */ }

  if (result && result.isValid()) {
    return result.format('[às] HH:mm[h]');
  }

  return undefined;
}
